<template>
    <div>
        <v-btn
            @click="toggleAddDialog()"
            class="info text--white"
            slot="activator"
        >Add Vehicle
        </v-btn>
        <v-dialog
            :value="addPersonVehicleDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Add Vehicle</span>
                    <v-spacer />
                    <v-btn
                        @click="toggleAddDialog()"
                        fab
                        small
                        text
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addRegistrationNumberErrors"
                                    @blur="$v.addRegistrationNumber.$touch()"
                                    @input="$v.addRegistrationNumber.$touch()"

                                    label="Registration Number"
                                    type="text"
                                    v-model="addRegistrationNumber"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addEngineSizeErrors"
                                    @blur="$v.addEngineSize.$touch()"
                                    @input="$v.addEngineSize.$touch()"
                                    label="Engine Size (Litres)"
                                    max="5"
                                    min="0"

                                    step="0.1"
                                    type="number"
                                    v-model="addEngineSize"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-select
                                    :error-messages="addFuelTypeErrors"
                                    :items="fuelTypeList"
                                    @blur="$v.addFuelType.$touch()"

                                    @input="$v.addFuelType.$touch()"
                                    label="Fuel Type"
                                    v-model="addFuelType"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addMileageRateErrors"
                                    @blur="$v.addMileageRate.$touch()"
                                    @input="$v.addMileageRate.$touch()"
                                    label="Mileage Rate"
                                    max="20"
                                    min="0"

                                    step="0.1"
                                    type="number"
                                    v-model="addMileageRate"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addVatMileageErrors"
                                    @blur="$v.addVatMileage.$touch()"
                                    @input="$v.addVatMileage.$touch()"
                                    label="Mileage VAT"
                                    max="20"
                                    min="0"
                                    type="number"
                                    v-model="addVatMileage"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-select
                                    :error-messages="addOwnershipTypeErrors"
                                    :items="ownershipTypeList"
                                    @blur="$v.addOwnershipType.$touch()"
                                    @input="$v.addOwnershipType.$touch()"
                                    label="Ownership Type"
                                    v-model="addOwnershipType"
                                />
                            </v-flex>

                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"

                                    v-model="startDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :value="addStartDate"
                                            label="Start Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        @input="startDateMenu = false"
                                        no-title
                                        scrollable
                                        v-model="addStartDate"
                                    />
                                </v-menu>
                            </v-flex>

                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-select
                                    :error-messages="addIsCurrentErrors"
                                    :items="[{Id: true, name: 'Current'}, {Id: false, name: 'Not Current'}]"
                                    @blur="$v.addIsCurrent.$touch()"
                                    @input="$v.addIsCurrent.$touch()"
                                    item-text="name"

                                    item-value="Id"
                                    label="Filter by Current"
                                    v-model="addIsCurrent"
                                />
                            </v-flex>

                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Comments"
                                    v-model="addComments"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveNewItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeNewItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { FETCH_PERSON_VEHICLE_LIST, SAVE_NEW_PERSON_VEHICLE } from "@/store/person_vehicle/actions.js";
import { RESET_DEFAULT_NEW_PERSON_VEHICLE, TOGGLE_NEW_PERSON_VEHICLE_DIALOG, UPDATE_ADD_PERSON_VEHICLE_FIELD } from "@/store/person_vehicle/mutations.js";
import { required, } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from '../editTableFunctions';

    export default {
        name: "AddPersonVehicleDialog",

        validations: {
            addRegistrationNumber: {required},
            addEngineSize: {required},
            addFuelType: {required},
            addMileageRate: {required},
            addVatMileage: {required},
            addOwnershipType: {required},
            addStartDate: {required},
            addIsCurrent: {required},
        },

        mixins: [
            EditTableFunctions,
        ],
        props: {
            personId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                startDateMenu: false,
            }
        },
        computed: {
            ...mapGetters(
            [

                "employmentTypeList",
                "jobList",
                "person",

            ],
            ),

            ...mapGetters(
            [
                "addPersonVehicleDialog",
                "fiscalYearList",
                "fuelTypeList",
                "ownershipTypeList",
            ]
            ),

            addRegistrationNumber: {
                get() {
                    return this.$store.state.person_vehicle.addPersonVehicle.registrationNumber;
                },
                set(value) {
                    this.updateNewValue('registrationNumber', value);
                },
            },
            addRegistrationNumberErrors() {
                const errors = [];
                if (!this.$v.addRegistrationNumber.$dirty) return errors;
                !this.$v.addRegistrationNumber.required && errors.push('required.');
                return errors
            },
            addEngineSize: {
                get() {
                    return this.$store.state.person_vehicle.addPersonVehicle.engineSize;
                },
                set(value) {
                    this.updateNewValue('engineSize', value);
                },
            },
            addEngineSizeErrors() {
                const errors = [];
                if (!this.$v.addEngineSize.$dirty) return errors;
                !this.$v.addEngineSize.required && errors.push('required.');
                return errors
            },
            addFuelType: {
                get() {
                    return this.$store.state.person_vehicle.addPersonVehicle.fuelType;
                },
                set(value) {
                    this.updateNewValue('fuelType', value);
                },
            },
            addFuelTypeErrors() {
                const errors = [];
                if (!this.$v.addFuelType.$dirty) return errors;
                !this.$v.addFuelType.required && errors.push('required.');
                return errors
            },
            addMileageRate: {
                get() {
                    return this.$store.state.person_vehicle.addPersonVehicle.mileageRate;
                },
                set(value) {
                    this.updateNewValue('mileageRate', value);
                },
            },
            addMileageRateErrors() {
                const errors = [];
                if (!this.$v.addMileageRate.$dirty) return errors;
                !this.$v.addMileageRate.required && errors.push('required.');
                return errors
            },
            addVatMileage: {
                get() {
                    return this.$store.state.person_vehicle.addPersonVehicle.vatMileage;
                },
                set(value) {
                    this.updateNewValue('vatMileage', value);
                },
            },
            addVatMileageErrors() {
                const errors = [];
                if (!this.$v.addVatMileage.$dirty) return errors;
                !this.$v.addVatMileage.required && errors.push('required.');
                return errors
            },
            addOwnershipType: {
                get() {
                    return this.$store.state.person_vehicle.addPersonVehicle.ownershipType;
                },
                set(value) {
                    this.updateNewValue('ownershipType', value);
                },
            },
            addOwnershipTypeErrors() {
                const errors = [];
                if (!this.$v.addOwnershipType.$dirty) return errors;
                !this.$v.addOwnershipType.required && errors.push('required.');
                return errors
            },
            addStartDate: {
                get() {
                    return this.$options.filters.formatDate(this.$store.state.person_vehicle.addPersonVehicle.startDate);
                },
                set(value) {
                    this.updateNewValue('startDate', value);
                },
            },
            addStartDateErrors() {
                const errors = [];
                if (!this.$v.addStartDate.$dirty) return errors;
                !this.$v.addStartDate.required && errors.push('required.');
                return errors
            },
            addIsCurrent: {
                get() {
                    return this.$store.state.person_vehicle.addPersonVehicle.isCurrent;
                },
                set(value) {
                    this.updateNewValue('isCurrent', value);
                },
            },
            addIsCurrentErrors() {
                const errors = [];
                if (!this.$v.addIsCurrent.$dirty) return errors;
                !this.$v.addIsCurrent.required && errors.push('required.');
                return errors
            },
            addComments: {
                get() {
                    return this.$store.state.person_vehicle.addPersonVehicle.comments;
                },
                set(value) {
                    this.updateNewValue('comments', value);
                },
            },
        },

        mounted() {
            if (this.personId !== undefined) {
                this.resetNewItemToDefault(this.personId);
                this.updateNewValue('personId', this.personId);
            }
        },

        methods: {
            ...mapActions({
                fetchTableList: FETCH_PERSON_VEHICLE_LIST,
                saveNewTableItemRecord: SAVE_NEW_PERSON_VEHICLE,
            }),
            //
            ...mapMutations({
                toggleAddDialog: TOGGLE_NEW_PERSON_VEHICLE_DIALOG,
                // loadTableItemToEdit: LOAD_PERSON_SUMMARY_TO_EDIT,
                updateTableItemToAdd: UPDATE_ADD_PERSON_VEHICLE_FIELD,
                resetNewItemToDefault: RESET_DEFAULT_NEW_PERSON_VEHICLE,
            }),
        }
    }
</script>

<style scoped>

</style>
